export const GIFT_TABLE_STATUS = {
  OPEN: 'Open',
  CANCEL: 'Cancel',
};
